import { type DevScenario, hasDevScenario } from '@arya/shared/domain';
import type { DevScenarioEntry } from '@arya/shared/msw-cloudflare';

import { delay, http, passthrough } from 'msw';

const SLOW_API_DELAY_MS = 3000;

const SLOW_API_SCENARIO: DevScenario = {
  name: 'slow-api',
  group: 'Network',
  title: 'Slow API',
  description: 'Every other API read waits 3 s, so loading states and skeletons stay on screen.',
};

export const SLOW_API: DevScenarioEntry = {
  scenario: SLOW_API_SCENARIO,
  handler: http.all(
    ({ request }) => request.method === 'GET' && hasDevScenario(request, SLOW_API_SCENARIO),
    async () => {
      await delay(SLOW_API_DELAY_MS);
      return passthrough();
    }
  ),
};
